import AvatarsGroupComp from './AvatarsGroup';
import CustomAvatarComp from './CustomAvatar';

export const AvatarsGroup = AvatarsGroupComp;
export const CustomAvatar = CustomAvatarComp;
